import { useMutation, useQuery } from '@tanstack/react-query';

import { DuRoleEnum } from '../enum/DuRoleEnum';
import { UserResponse } from '../models/UserResponse';
import axiosBearerClient from '../axiosBearerClient';

export const useGetUsers = (sdpId?: string) => {
  const { isFetching, error, data, isError, refetch } = useQuery({
    queryKey: ['users'],
    gcTime: 0,
    enabled: !!sdpId,
    retry: false,
    queryFn: async () => {
      try {
        const response = await axiosBearerClient.get<UserResponse[]>(
          `/users/${sdpId}?role=${DuRoleEnum.DELEGATE}&isDeleted=NO`
        );
        if (response.data) {
          return response;
        } else {
          return { data: [] };
        }
      } catch (error) {
        throw error;
      }
    },
  });

  return {
    isFetching,
    error,
    isError,
    data,
    refetch,
  };
};

export const useDeleteUser = () => {
  const { isPending, error, data, isError, mutateAsync } = useMutation({
    retry: false,
    mutationFn: async ({ email, sdpId }: { email: string; sdpId: string }) => {
      return await axiosBearerClient.delete(`/users/${email}/${sdpId}`);
    },
  });

  return {
    isPending,
    error,
    isError,
    data,
    mutateAsync,
  };
};
